import axios from "axios";

export default {
    namespaced: true,
    state: () => ({
        countryList: [],
        statelistByCountry: [],
        suggestedCountry:""
    }),
    getters: {
        getCountryList:state=>state.countryList,
        getStateList:state=>land=>state.statelistByCountry[land] || [],
        getSuggestedCountry:state=>state.suggestedCountry,
        getStateByKuerzel:state=>(landKuerzel, statekuerzel)=>{
            const stateList = state.statelistByCountry[landKuerzel];
            if(stateList === undefined) {
                return statekuerzel;
            }
            const entry = stateList.find(e=>e.kuerzel === statekuerzel);
            if(entry === undefined) {
                return statekuerzel;
            }
            return entry.state;
        },
        getCountryByIso3166:state=>iso3166=>{
            const entry = state.countryList.find(e=>e.iso3166 === iso3166);
            if(entry === undefined) {
                return iso3166;
            }
            return entry.landIntName;
        }
    },
    mutations: {
        SET_COUNTRYLIST(state, countrylist){
            state.countryList = countrylist;
        },
        SET_STATELIST(state, statelistByCountry){
            state.statelistByCountry = statelistByCountry
        },
        SET_SUGGESTED_COUNTRY(state, suggestedCountry){
            state.suggestedCountry = suggestedCountry;
        }
    },
    actions: {
        loadCountryList(context, language) {
            axios("/konfigurator_php/actionmodul/countryList.php?lang=" + language)
                .then(response => {
                    context.commit("SET_COUNTRYLIST", response.data.countryList)
                    context.commit("SET_STATELIST", response.data.stateList)
                    context.commit("SET_SUGGESTED_COUNTRY", response.data.suggestedCountry)
                })
        }
    }
}
